"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onPrefetchPathname = exports.shouldUpdateScroll = exports.onPreRouteUpdate = exports.onRouteUpdate = exports.replaceHydrateFunction = void 0;
/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
const react_1 = __importDefault(require("react"));
const client_1 = require("react-dom/client");
const prefetcher_1 = require("../components/filter/prefetcher");
const lenis_1 = __importDefault(require("@studio-freight/lenis"));
const gsap_1 = require("gsap");
const ScrollTrigger_1 = require("gsap/ScrollTrigger");
gsap_1.gsap.registerPlugin(ScrollTrigger_1.ScrollTrigger);
let lenis;
const replaceHydrateFunction = () => {
    return (element, container) => {
        const store = (0, prefetcher_1.createPrefetch)();
        if (process.env.NODE_ENV === "development") {
            const root = (0, client_1.createRoot)(container);
            root.render(react_1.default.createElement(prefetcher_1.Prefetch, { provider: store }, element));
        }
        else {
            const root = (0, client_1.hydrateRoot)(container, (react_1.default.createElement(prefetcher_1.Prefetch, { provider: store }, element)));
        }
    };
};
exports.replaceHydrateFunction = replaceHydrateFunction;
const onRouteUpdate = ({ location, prevLocation }) => {
    if (lenis) {
        lenis.destroy();
    }
    lenis = new lenis_1.default();
    lenis.on('scroll', ScrollTrigger_1.ScrollTrigger.update);
    gsap_1.gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
    });
    gsap_1.gsap.ticker.lagSmoothing(0);
    const hash = window.gatsby_router_hash;
    const scrollToHash = () => {
        const scrollOffset = -100;
        const element = document.getElementById(hash?.substr(1));
        if (element) {
            const top = element.getBoundingClientRect().top + window.scrollY + scrollOffset;
            lenis.scrollTo(top, { immediate: true });
        }
    };
    if (hash) {
        if (prevLocation?.pathname === location.pathname) {
            scrollToHash();
        }
        else {
            setTimeout(scrollToHash, 300);
        }
        window.gatsby_router_hash = undefined;
    }
    ScrollTrigger_1.ScrollTrigger.refresh();
};
exports.onRouteUpdate = onRouteUpdate;
const onPreRouteUpdate = ({ location, prevLocation }) => {
    fetchRunner(location.pathname);
    if (lenis) {
        lenis.destroy();
        gsap_1.gsap.ticker.remove(() => { });
        lenis = null;
    }
};
exports.onPreRouteUpdate = onPreRouteUpdate;
/*
* If the pathnames are the same, and there is a router hash, don't use in-built page scroll updating
* */
const shouldUpdateScroll = ({ prevRouterProps, routerProps }) => !(prevRouterProps?.location?.pathname
    === routerProps?.location?.pathname && window.gatsby_router_hash);
exports.shouldUpdateScroll = shouldUpdateScroll;
const fetchRunner = (pathname, callback = null) => {
    if (process.env.NODE_ENV === "production" && pathname) {
        const requestedPath = pathname.split("?")[0].split("/").filter(x => !!x).join("/");
        fetch(`/__qstore/${requestedPath ? `${requestedPath}/` : ""}index.json`)
            .then((res) => {
            if (res.ok) {
                return res.json();
            }
            else if (callback) {
                callback();
            }
        })
            .then(provider => {
            if (provider) {
                Object.entries(provider.fulfilledQueries).forEach(([hash, data]) => {
                    const queryArgs = provider.queries[hash];
                    prefetcher_1.queryClient.setQueryData([JSON.stringify(queryArgs)], {
                        pageParams: [1],
                        pages: [data]
                    });
                });
                Object.entries(provider.fulfilledDependents).forEach(([id, data]) => {
                    prefetcher_1.queryClient.setQueryData(['scoped-id', id], data);
                });
                if (callback) {
                    callback();
                }
            }
        });
    }
};
const onPrefetchPathname = ({ pathname }) => {
    fetchRunner(pathname);
};
exports.onPrefetchPathname = onPrefetchPathname;
//# sourceMappingURL=browser.js.map